// import { Box, Typography, useTheme, Grid, List, ListItem, ListItemIcon } from '@mui/material';
// import React from 'react';
// import { FaHospital, FaUserMd } from 'react-icons/fa';
// import { FiberManualRecord as BulletPointIcon } from '@mui/icons-material';
// import { ArrayField, CareTextField, SectionHeader } from '../Components';
// import { SectionProps, CarePlanFieldPath } from '../../../../types/ndisSection/carePlanInfoTypes';

// const getNestedValue = (obj: any, path: string): string => {
//   if (!obj) return 'Not provided';
//   const keys = path.split('.');
//   let current = obj;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return 'Not provided';
//     }
//   }
//   return current || 'Not provided';
// };

// const MedicalProfessionalsSection: React.FC<SectionProps> = ({
//   editMode,
//   isMobile,
//   handleEditToggle,
//   handleSubmit,
//   handleCancel,
//   control,
//   errors,
//   getValues,
//   carePlan,
//   diabeticCare,
//   setDiabeticCare
// }) => {
//   const theme = useTheme();
//   const spacing = isMobile ? 1 : 2;

//   const fields: { label: string; name: CarePlanFieldPath; icon: JSX.Element }[] = [
//     { label: 'GP Name', name: 'MedicalProfessionals.GP' as CarePlanFieldPath, icon: <FaUserMd /> }
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: 2,
//         boxShadow: theme.shadows[1],
//         overflow: 'hidden',
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto'
//       }}
//     >
//       <SectionHeader
//         icon={<FaHospital size={isMobile ? 16 : 20} />}
//         title="Medical Professionals"
//         color={theme.palette.info.main}
//         editMode={editMode}
//         handleEditToggle={handleEditToggle}
//         handleSubmit={handleSubmit}
//         handleCancel={handleCancel}
//         getValues={getValues}
//       />

//       <Box sx={{ p: isMobile ? 1 : 2 }}>
//         {editMode ? (
//           <>
//             <Grid container spacing={spacing}>
//               {fields.map((field) => (
//                 <Grid item xs={12} key={field.name}>
//                   <CareTextField
//                     label={field.label}
//                     name={field.name}
//                     control={control}
//                     errors={errors}
//                     getValues={getValues}
//                     icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
//                     size={isMobile ? 'small' : 'medium'}
//                   />
//                 </Grid>
//               ))}
//               <Grid item xs={12}>
//                 <ArrayField
//                   name="MedicalProfessionals.Specialist.DiabeticCare"
//                   label="Diabetic Care"
//                   icon={<FaUserMd size={isMobile ? 14 : 16} />}
//                   color={theme.palette.info.main}
//                   items={diabeticCare}
//                   setItems={setDiabeticCare}
//                   editMode={editMode}
//                   errors={errors}
//                 />
//               </Grid>
//             </Grid>
//           </>
//         ) : (
//           <>
//             <Grid container spacing={spacing}>
//               {fields.map((field) => {
//                 const value = getNestedValue(carePlan, field.name);
//                 return (
//                   <Grid item xs={12} key={field.name}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1,
//                         p: isMobile ? 1 : 1.5,
//                         backgroundColor: theme.palette.background.default,
//                         borderRadius: 1,
//                         height: '100%',
//                         minHeight: isMobile ? 56 : 64,
//                         transition: 'all 0.2s ease',
//                         '&:hover': {
//                           backgroundColor: theme.palette.action.hover
//                         }
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: theme.palette.info.light,
//                           color: theme.palette.info.contrastText,
//                           borderRadius: '50%',
//                           width: isMobile ? 32 : 36,
//                           height: isMobile ? 32 : 36,
//                           flexShrink: 0
//                         }}
//                       >
//                         {React.cloneElement(field.icon, {
//                           size: isMobile ? 14 : 16
//                         })}
//                       </Box>
//                       <Box sx={{ overflow: 'hidden', flex: 1 }}>
//                         <Typography
//                           variant={isMobile ? 'caption' : 'subtitle2'}
//                           sx={{
//                             fontWeight: 500,
//                             color: theme.palette.text.secondary,
//                             lineHeight: 1.2
//                           }}
//                         >
//                           {field.label}
//                         </Typography>
//                         <Typography
//                           variant={isMobile ? 'body2' : 'body1'}
//                           sx={{
//                             fontWeight: 400,
//                             color: theme.palette.text.primary,
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis',
//                             display: '-webkit-box',
//                             WebkitLineClamp: 2,
//                             WebkitBoxOrient: 'vertical'
//                           }}
//                         >
//                           {value}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 );
//               })}
//               <Grid item xs={12}>
//                 <Box
//                   sx={{
//                     p: isMobile ? 1 : 2,
//                     backgroundColor: theme.palette.background.default,
//                     borderRadius: 1,
//                     transition: 'all 0.2s ease',
//                     '&:hover': {
//                       backgroundColor: theme.palette.action.hover
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       mb: 1
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: theme.palette.info.light,
//                         color: theme.palette.info.contrastText,
//                         borderRadius: '50%',
//                         width: isMobile ? 32 : 36,
//                         height: isMobile ? 32 : 36,
//                         flexShrink: 0
//                       }}
//                     >
//                       <FaUserMd size={isMobile ? 14 : 16} />
//                     </Box>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'h6'}
//                       sx={{
//                         fontWeight: 500,
//                         color: theme.palette.text.secondary
//                       }}
//                     >
//                       Diabetic Care
//                     </Typography>
//                   </Box>

//                   {diabeticCare?.length > 0 ? (
//                     <List dense sx={{ py: 0 }}>
//                       {diabeticCare.map((item, index) => (
//                         <ListItem key={index} sx={{ py: 0.5, px: 1 }}>
//                           <ListItemIcon sx={{ minWidth: 24 }}>
//                             <BulletPointIcon
//                               sx={{ fontSize: '0.8rem', color: theme.palette.text.secondary }}
//                             />
//                           </ListItemIcon>
//                           <Typography variant="body2">{item}</Typography>
//                         </ListItem>
//                       ))}
//                     </List>
//                   ) : (
//                     <Typography variant="body2" sx={{ fontStyle: 'italic', pl: 4 }}>
//                       No diabetic care professionals listed
//                     </Typography>
//                   )}
//                 </Box>
//               </Grid>
//             </Grid>
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default MedicalProfessionalsSection;

import React from 'react';
import { Box, Typography, useTheme, Paper, Grid, IconButton, Button } from '@mui/material';
import { FaHospital, FaUserMd, FaTrash, FaPlus } from 'react-icons/fa';
import { useFieldArray, useFormContext } from 'react-hook-form';
import {
  SectionProps,
  MedicalProfessionals,
  CarePlan,
  CarePlanFieldPath
} from '../../../../types/ndisSection/carePlanInfoTypes';
import { CareTextField, SectionHeader } from '../Components';

const getNestedValue = (obj: any, path: string): string => {
  if (!obj) return 'Not provided';
  try {
    const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');
    return (
      keys.reduce((acc, key) => (acc && key in acc ? acc[key] : 'Not provided'), obj) ||
      'Not provided'
    );
  } catch {
    return 'Not provided';
  }
};

const MedicalProfessionalsSection: React.FC<SectionProps> = ({
  editMode,
  isMobile,
  handleEditToggle,
  handleSubmit,
  handleCancel,
  control,
  errors,
  getValues,
  setValue,
  carePlan
}) => {
  const theme = useTheme();
  const spacing = isMobile ? 1 : 2;
  const { watch } = useFormContext<CarePlan>();

  const { fields, append, remove } = useFieldArray<CarePlan, 'MedicalProfessionals', 'id'>({
    control,
    name: 'MedicalProfessionals',
    keyName: 'id'
  });

  const defaultProfessional: MedicalProfessionals = {
    GP: '',
    AlliedHealth: '',
    Specialist: {
      SpecialistCare: ['']
    }
  };

  const handleAddSpecialist = (mainIndex: number) => {
    const current = getValues(`MedicalProfessionals.${mainIndex}.Specialist.SpecialistCare`) || [];
    const updated = [...current, ''];
    setValue(`MedicalProfessionals.${mainIndex}.Specialist.SpecialistCare`, updated);
  };

  const handleRemoveSpecialist = (mainIndex: number, innerIndex: number) => {
    const current = getValues(`MedicalProfessionals.${mainIndex}.Specialist.SpecialistCare`) || [];
    const updated = current.filter((_: any, i: number) => i !== innerIndex);
    setValue(`MedicalProfessionals.${mainIndex}.Specialist.SpecialistCare`, updated);
  };

  return (
    <Paper
      elevation={2}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100%',
        mx: 'auto'
      }}
    >
      <SectionHeader
        icon={<FaHospital size={isMobile ? 16 : 20} />}
        title="Medical Professionals"
        color={theme.palette.info.main}
        editMode={editMode}
        handleEditToggle={handleEditToggle}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        getValues={getValues}
      />

      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {editMode ? (
          <>
            {fields.map((professional, index) => {
              const specialistCare =
                watch(`MedicalProfessionals.${index}.Specialist.SpecialistCare`) || [];

              return (
                <Box
                  key={professional.id}
                  sx={{
                    mb: 3,
                    p: 2,
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1
                  }}
                >
                  <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ mb: 2 }}>
                    Medical Professional {index + 1}
                  </Typography>
                  <Grid container spacing={spacing}>
                    <Grid item xs={12}>
                      <CareTextField
                        label="GP Name"
                        name={`MedicalProfessionals[${index}].GP` as CarePlanFieldPath}
                        control={control}
                        errors={errors}
                        getValues={getValues}
                        icon={<FaUserMd size={isMobile ? 14 : 16} />}
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <CareTextField
                        label="Allied Health"
                        name={`MedicalProfessionals[${index}].AlliedHealth` as CarePlanFieldPath}
                        control={control}
                        errors={errors}
                        getValues={getValues}
                        icon={<FaUserMd size={isMobile ? 14 : 16} />}
                        size={isMobile ? 'small' : 'medium'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                        Specialist Care
                      </Typography>
                      {specialistCare.map((_: any, specialistIndex: number) => (
                        <Grid container spacing={spacing} key={specialistIndex} sx={{ mb: 1 }}>
                          <Grid item xs={10}>
                            <CareTextField
                              label={`Specialist Care ${specialistIndex + 1}`}
                              name={
                                `MedicalProfessionals[${index}].Specialist.SpecialistCare[${specialistIndex}]` as CarePlanFieldPath
                              }
                              control={control}
                              errors={errors}
                              getValues={getValues}
                              icon={<FaUserMd size={isMobile ? 14 : 16} />}
                              size={isMobile ? 'small' : 'medium'}
                            />
                          </Grid>
                          <Grid item xs={2} textAlign="right">
                            <IconButton
                              onClick={() => handleRemoveSpecialist(index, specialistIndex)}
                              color="error"
                            >
                              <FaTrash />
                            </IconButton>
                          </Grid>
                        </Grid>
                      ))}
                      <Button
                        startIcon={<FaPlus />}
                        variant="outlined"
                        onClick={() => handleAddSpecialist(index)}
                        sx={{ mt: 1 }}
                      >
                        Add Specialist Care
                      </Button>
                    </Grid>
                    <Grid item xs={12} textAlign="right">
                      <IconButton onClick={() => remove(index)} color="error">
                        <FaTrash />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
            <Button
              startIcon={<FaPlus />}
              variant="outlined"
              onClick={() => append(defaultProfessional)}
              sx={{ mt: 2 }}
            >
              Add Medical Professional
            </Button>
          </>
        ) : (
          <>
            {carePlan &&
            Array.isArray(carePlan.MedicalProfessionals) &&
            carePlan.MedicalProfessionals.length > 0 ? (
              carePlan.MedicalProfessionals.map((professional, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  sx={{
                    p: isMobile ? 1.5 : 2,
                    backgroundColor: theme.palette.background.default,
                    borderRadius: 1,
                    mb: 2
                  }}
                >
                  <Typography variant={isMobile ? 'subtitle1' : 'h6'} sx={{ mb: 1 }}>
                    Medical Professional {index + 1}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>GP Name:</strong>{' '}
                    {getNestedValue(carePlan, `MedicalProfessionals[${index}].GP`)}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Allied Health:</strong>{' '}
                    {getNestedValue(carePlan, `MedicalProfessionals[${index}].AlliedHealth`)}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    Specialist Care:
                  </Typography>
                  {professional?.Specialist?.SpecialistCare?.length ? (
                    professional.Specialist.SpecialistCare.map((item, idx) => (
                      <Typography key={idx} variant="body2" sx={{ ml: 2 }}>
                        • {item || 'Not provided'}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body2" sx={{ ml: 2, fontStyle: 'italic' }}>
                      No specialist care listed
                    </Typography>
                  )}
                </Paper>
              ))
            ) : (
              <Typography variant="body2" sx={{ fontStyle: 'italic', p: 2 }}>
                No medical professionals listed
              </Typography>
            )}
          </>
        )}
      </Box>
    </Paper>
  );
};

export default MedicalProfessionalsSection;